export const tickToDate = (tick) => {
  const convertedDate = new Date(0)
  convertedDate.setUTCSeconds(tick)
  return convertedDate
}
